import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import Vue from 'vue'
import router from './router/index'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { UnauthorizedException } from './api'
import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faFileSignature,
  faHandHoldingHeart,
  faCheckCircle,
  faSearch,
  faBackspace,
  faTimesCircle,
  faTrashAlt,
  faUser,
  faKey,
  faSignInAlt,
  faSignOutAlt,
  faPiggyBank,
  faDownload,
  faChartLine,
  faTags,
  faEnvelope,
  faCog,
  faHandPointer,
  faPencilAlt,
  faPlusCircle,
  faClipboard
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faFileSignature,
  faHandHoldingHeart,
  faCheckCircle,
  faSearch,
  faBackspace,
  faTimesCircle,
  faTrashAlt,
  faUser,
  faKey,
  faSignInAlt,
  faSignOutAlt,
  faPiggyBank,
  faDownload,
  faChartLine,
  faTags,
  faEnvelope,
  faCog,
  faHandPointer,
  faPencilAlt,
  faPlusCircle,
  faClipboard
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(BootstrapVue)

Vue.config.productionTip = false

Vue.config.errorHandler = (err, vm, _info) => {
  if (err instanceof UnauthorizedException) {
    vm.$router.push('/admin/login')
  }
}

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app')
